import { render } from "./HouseIdApp.vue?vue&type=template&id=10b5a96c&scoped=true&ts=true"
import script from "./HouseIdApp.vue?vue&type=script&lang=ts"
export * from "./HouseIdApp.vue?vue&type=script&lang=ts"

import "./HouseIdApp.vue?vue&type=style&index=0&id=10b5a96c&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/my-pages-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10b5a96c"]])

export default __exports__